/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;

  var order = function order() {
    var url = "";
    if (window.wallet == "true") url = "json/walletWithdraw.aspx";else url = '';
    $f7.request({
      method: 'get',
      url: window.waypointGEN + url,
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        amount: $("#withdraw").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        data = data.replace(",\"{", ",{");
        var data = JSON.parse(data);
        console.log(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.print_text = "{CENTER}";
          window.print_text += "{BR}{BR}";
          window.print_text += "{BR}{BR}TOPUP TOTAL : $" + data.total;
          window.print_text += "{BR}{BR}";
          window.print_qr = data.orderId; //window.print_barcode = data.orderId;

          window.print_hide_button = "true";
          window.print_detail = "\n            <div class=\"block\">\n              Please present the QR to cashier to withdraw as follow:\n            </div>\n            <div class=\"card data-table\">\n            <table>\n              <thead>\n                <tr>\n                  <th class=\"label-cell\">Type</th>\n                  <th class=\"numeric-cell\">Amount</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td class=\"label-cell\">Withdraw</td>\n                  <td class=\"numeric-cell\">" + $("#withdraw").val() + "</td>\n                </tr>\n              </tbody>\n            </table>\n            <div class=\"data-table-footer\">\n              <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n            </div>\n          </div>\n            ";
          $f7.views.main.router.navigate("/GEN_receipt/");
        } else {
          $f7.dialog.alert(data.errmsg);
        }
      }
    });
  };

  $on('pageInit', function () {
    $('.wallet-amount').html("$" + window.wallet_amount);

    if (window.wallet == "true") {
      $(".wallet-off").hide();
      $(".wallet-on").show();
    } else {
      $(".wallet-off").show();
      $(".wallet-on").hide();
    }

    $("#orderId").focus();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Withdraw</span>
        <span class='cn'>提取</span>
        <span class='tl'>Foti</span>
      </div>
    </div>
  </div>
  <div class="page-content">


    <div class="data-table card wallet-on" style="background-color: var(--f7-theme-color);">
      <div class="card-content ">
        <table>
          <thead>
          <th >e-Wallet Amount</th>
          <th class="numeric-cell wallet-amount" style="font-size: 20px; color: white;"></th>
          </thead>
          <tbody>
          </tbody>  
        </table>
      </div>
    </div>


    <div class="block-title">
      <span class='en'>Withdraw Amount</span>
      <span class='cn'>取款数量</span>
      <span class='tl'>Montante Levantamentu</span>
    </div>

    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Amount</span>
              <span class='cn'>数量</span>
              <span class='tl'>montante</span>
            </div>
            <div class="item-input-wrap">
              <input type="number" id="withdraw" placeholder="0.00"/>
            </div>
          </div>
        </li>
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${order}">
              <span class='en'>Withdraw</span>
              <span class='cn'>提取</span>
              <span class='tl'>Foti</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '60f4048184';
export default framework7Component;